import { getSettingHelpCenterAIChatbotEntrypoint } from "@faire/help-center-utils/settings/getSettingHelpCenterAIChatbotEntrypoint";
import { useViewport } from "@faire/web/ui/hooks/useViewport";
import React from "react";
import { ContactUsMainBannerDesktop } from "./ContactUsMainBannerDesktop";
import { ContactUsSideBanner } from "./ContactUsSideBanner";
import { NeedMoreHelpBanner } from "./NeedMoreHelpBanner";
export var ContactUsMainBanner = function ContactUsMainBanner(_ref) {
  var borderPosition = _ref.borderPosition;
  var _useViewport = useViewport(),
    isMobile = _useViewport.isMobile;
  if (getSettingHelpCenterAIChatbotEntrypoint()) {
    return /*#__PURE__*/React.createElement(NeedMoreHelpBanner, null);
  }
  return isMobile ? ( /*#__PURE__*/React.createElement(ContactUsSideBanner, {
    isFooter: true
  })) : ( /*#__PURE__*/React.createElement(ContactUsMainBannerDesktop, {
    borderPosition: borderPosition
  }));
};